import { useQuery } from "@tanstack/react-query";
import { authorizedAxios } from "@moonscape/shared";
import { useAuth } from "@moonscape/shared";
import { minutes } from "@/utils";

export interface AssetCostBasis {
  asset: string;
  remaining_qty: number;
  cost_basis: number;
  has_claim: boolean;
  claim_id: number | null;
}

export interface AssetCostBasisResponse {
  success: boolean;
  data: AssetCostBasis[];
}

export const useAssetCostBasis = () => {
  const { user, getToken } = useAuth();
  const email = user?.email;

  const getCostBasis = async (): Promise<AssetCostBasis[]> => {
    const url = `/loss-writeoff-claims/cost-basis`;
    const token = await getToken();
    const res = await authorizedAxios(token).get<AssetCostBasisResponse>(url);
    return res.data.data;
  };

  return useQuery({
    queryKey: ["assetCostBasis"],
    queryFn: getCostBasis,
    enabled: !!email,
    refetchOnWindowFocus: true,
    staleTime: 1 * minutes,
    refetchInterval: 5 * minutes,
  });
};
